enum PaymentStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  CANCEL = 'CANCEL'
}

export default PaymentStatus;
